export const getBisambergData = () => ({
  name: "Bisamberg",
  region: "Wien",
  country: "Autriche",
  description: "Bisamberg est une colline viticole de Wien, produisant des vins rouges et blancs équilibrés. Cette région bénéficie d'un climat continental tempéré, créant des conditions favorables pour une viticulture diversifiée.",
  type: "subregion",
  area: "150 ha",
  production: "0.008 million hectolitres",
  climate: "Climat continental tempéré, étés modérés et hivers froids",
  soil: "Sols argileux, calcaires, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental tempéré, étés modérés et hivers froids",
    soil: "Sols argileux, calcaires, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements modérés, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs secs et équilibrés, avec une acidité modérée",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Bisamberg remonte à l'époque romaine. La colline a développé une réputation pour ses vins équilibrés, notamment les vins rouges et blancs. Aujourd'hui, Bisamberg est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine viennoise traditionnelle, viandes, fromages affinés, cuisine internationale",
  grapeVarieties: [
    {
      name: "Zweigelt",
      percentage: "40%",
      description: "Cépage rouge principal, produisant des vins légers et aromatiques",
      characteristics: "Léger, aromatique, tanins fins",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Blaufränkisch",
      percentage: "25%",
      description: "Cépage rouge produisant des vins légers et fruités",
      characteristics: "Léger, fruité, tanins fins",
      wineStyles: "Sec, léger, fruité"
    },
    {
      name: "Grüner Veltliner",
      percentage: "20%",
      description: "Cépage emblématique d'Autriche, produisant des vins blancs secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Riesling",
      percentage: "10%",
      description: "Cépage blanc produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Bisamberg", x: 16.5, y: 48.3, color: "#6d2c7a", size: 2 }
  ]
}); 